import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/hourglass_grey_big.png'
import _imports_1 from '@/assets/images/no-ticket-data.png'
import _imports_2 from '@/assets/icons/clear-button-icon.svg'
import _imports_3 from '@/assets/icons/eject-button-icon.svg'
import _imports_4 from '@/assets/icons/delete-button-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-5a8c7a20"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup-container"
}
const _hoisted_2 = { class: "container-fluid d-flex flex-column h-100 drawer-inner px-0" }
const _hoisted_3 = { class: "row flex-grow-0" }
const _hoisted_4 = { class: "col-11 d-flex flex-column align-items-start justify-content-center" }
const _hoisted_5 = { class: "d-flex align-items-center gap-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "building-icon"
}, null, -1))
const _hoisted_7 = { class: "popup-title-text" }
const _hoisted_8 = { class: "col-1" }
const _hoisted_9 = { class: "drawer-content" }
const _hoisted_10 = { class: "tickets-scroll" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statistics-image-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_12 = { class: "no-data-label" }
const _hoisted_13 = { class: "tickets-grid" }
const _hoisted_14 = ["id"]
const _hoisted_15 = { class: "ticket-on-hold justify-content-between" }
const _hoisted_16 = { class: "ticket-buttons" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "actions-container mt-3 flex-shrink-0" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  class: "delete-icon"
}, null, -1))

import { ref, onMounted, onUnmounted, computed, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'LbrxOnHoldTicketsDrawer',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  waiting_list: {
    type: Array,
    required: true,
  },
},
  emits: ["close", "endTicket", "returnOnHoldTicket"],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "afd8930a": (_unref(FixBoxWidth))
}))





const waitingList = computed(() =>
  Array.isArray(props.waiting_list) ? props.waiting_list : []
);

function fixFontSize(public_identifier: string) {
  if (public_identifier.length > 3) {
    return "2.5vmin";
  }
  return "3.7vmin";
}

function fixLineHeight(public_identifier: string) {
  if (public_identifier.length > 3) {
    return "2.9vmin";
  }
  return "5.4vmin";
}

function onEndTicket(public_identifier: string) {
  emit("endTicket", public_identifier);
}

function onReturnOnHoldTicket(id: string | number) {
  emit("returnOnHoldTicket", id);
}
const showPopup = ref(false);

const closeThis = () => {
  showPopup.value = false;
  setTimeout(() => {
    emit("close");
  }, 700);
};


const FixBoxWidth = computed(() => {
  return "45%";
});


watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue) {
      
      //delay for animation
      setTimeout(() => {
        showPopup.value = true;
      }, 5);
    } else {
      showPopup.value = false;
      
    }
  },
  { immediate: true }
);



function onEscapeKey(event: KeyboardEvent) {
  if (event.key === "Escape") {
    closeThis();
  }
}

onMounted(() => {
  document.addEventListener("keyup", onEscapeKey);
});

onUnmounted(() => {
  document.removeEventListener("keyup", onEscapeKey);
});



return (_ctx: any,_cache: any) => {
  return (__props.modelValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (showPopup.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["popup-box", { 'right-class': _ctx.$i18n.locale === 'ar' }])
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _hoisted_6,
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("Teller.Waiting_Tickets")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (closeThis())),
                          class: "close-popup"
                        }, "X")
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        (_unref(waitingList).length === 0)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["no-data-container justify-content-around", { 'right-class': _ctx.$i18n.locale === 'ar' }])
                            }, [
                              _hoisted_11,
                              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("Teller.No_ticket")), 1)
                            ], 2))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["drawer-tickets-on-hold", { 'right-class': _ctx.$i18n.locale === 'ar' }])
                            }, [
                              _createElementVNode("div", _hoisted_13, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(waitingList), (item) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "ticket-grid-cell",
                                    id: 'drawer-onHold-' + item.public_identifier,
                                    key: item.ticket_id || item.public_identifier
                                  }, [
                                    _createElementVNode("div", _hoisted_15, [
                                      _createElementVNode("span", {
                                        class: "ticket-value",
                                        style: _normalizeStyle(
                          'font-size:' +
                          fixFontSize(
                            String(item.public_identifier).replace(' ', '')
                          ) +
                          ' !important; line-height: ' +
                          fixLineHeight(
                            String(item.public_identifier).replace(' ', '')
                          ) +
                          ' !important; '
                        )
                                      }, _toDisplayString(String(item.public_identifier).replace(" ", "")), 5),
                                      _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("img", {
                                          class: "ticket-button",
                                          src: _imports_2,
                                          alt: "Delete Ticket",
                                          onClick: ($event: any) => (onEndTicket(item.public_identifier))
                                        }, null, 8, _hoisted_17),
                                        _createElementVNode("img", {
                                          class: "ticket-button",
                                          src: _imports_3,
                                          alt: "Recall Ticket",
                                          onClick: ($event: any) => (onReturnOnHoldTicket(item.ticket_id))
                                        }, null, 8, _hoisted_18)
                                      ])
                                    ])
                                  ], 8, _hoisted_14))
                                }), 128))
                              ])
                            ], 2))
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("button", {
                          class: "btn btn-secondary d-flex align-items-center justify-content-center gap-2",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (closeThis()))
                        }, [
                          _hoisted_20,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("Teller.Cancel")), 1)
                        ])
                      ])
                    ])
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})